<template>
  <ProSpaceGeoLayout class="mars-periods">
    <template #top>
      <ProSpaceTopPanel :header="this.$t('marsPeriods')">
        <template #right>
          <ProSpaceIconButton
            icon="update"
            iconWidth="16px"
            iconHeight="16px"
            containerSize="20px"
            @click="actionUpdate"
          />
          <ProSpaceButton
            v-if="canShowBlockingAdjustmentsAction"
            type="primary"
            :label="selectedData && Object.keys(selectedData).length > 0 && selectedData.isBlocked ? $t('unBlockAdjustments') : $t('blockAdjustments')"
            :disabled="getDisabledBlockingAdjustmentsAction"
            @click="changeBlockingAdjustments"
          />
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout>
        <template #top>
          <ProSpaceFilterPanel
            :searchPlaceholder="$t('searchTxt')"
            :modelFastFilter="modelFastFilter"
            :fastFilters="fastFilters"
            :txtResetFilters="$t('txtResetFilters')"
            :unicKeyStorage="marsPeriodService.constructor.name + 'grid'"
            @apply="submitFilter"
            ref="filterPanel"
            filter-model="name"
            @update:modelFastFilter="
              (val) => {
                modelFastFilter = val;
              }
            "
            :blocked-filters="needBlock"
            @block="selectedMultipleBlockFilterHandler"
          >
            <template #hint>
              {{ this.$t("filterBy") }}
            </template>
            <template #filters="{ filter }">
              <ProSpaceMultiSelect
                :localization="$t"
                v-model="filter.status"
                :service="marsPeriodStatusService"
                getMethod="get"
                optionLabel="text"
                optionValue="status"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :placeholderValue="$t('status')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('resetTxt')"
                @apply="(model) => customFilterApply(filter, model)"
              />
              <ProSpaceCustomFilterPanel
                :customTxt="$t('custom')"
                :customFilterTxt="$t('customFilterTxt')"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('resetTxt')"
                :fromTxt="$t('fromTxt')"
                :toTxt="$t('toTxt')"
                :services="customServices"
                :unicKeyStorage="marsPeriodService.constructor.name + 'grid'"
                @apply="(model) => customFilterApply(filter, model)"
              />
            </template>
          </ProSpaceFilterPanel>
        </template>
        <template #center>
          <ProSpaceMainGrid
            ref="grid"
            :service="marsPeriodService"
            @selected-change="selectedHandler"
            :noMountedRequest="true"
            getMethod="grid"
            selectionMode="single"
          >
            <template #columns>
              <Column field="name" :header="$t('marsPeriodName')" sortable>
                <template #body="field">
                  <ProSpaceDefaultTextColumn>
                    {{ field.data.name }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>

              <Column field="status" :header="$t('marsPeriodStatus')" sortable style="max-width: 200px;">
                <template #body="field">
                  <ProSpaceDefaultTextColumn>
                    {{ field.data.status }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>

              <Column field="isBlocked" :header="$t('blockingAdjustments')" sortable style="min-width: 250px;">
                <template #body="field">
                  <ProSpaceDefaultTextColumn>
                    {{ getBlockingAdjustmentsValue(field.data.isBlocked) }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>

              <Column
                field="startDate"
                :header="$t('marsPeriodStartDate')"
                sortable
              >
                <template #body="field">
                  <ProSpaceDateColumn
                    :date="field.data.startDate"
                    :format="userinfo.dateFormat"
                  />
                </template>
              </Column>

              <Column
                field="endDate"
                :header="$t('marsPeriodEndDate')"
                sortable
              >
                <template #body="field">
                  <ProSpaceDateColumn
                    :date="field.data.endDate"
                    :format="userinfo.dateFormat"
                  />
                </template>
              </Column>

              <Column field="actions" class="column-end column-end-30">
                <template #body="field">
                  <ProSpaceDots
                    :options="dotsOptions"
                    @action="(action) => handleDots(action, field.data)"
                  ></ProSpaceDots>
                </template>
              </Column>
            </template>
            <template #empty>
              <ProSpaceEmptyGrid
                icon="error-message"
                :title="$t('noDataTitle')"
                :text="$t('noDataTxt')"
              />
            </template>
          </ProSpaceMainGrid>
        </template>
      </ProSpaceGeoLayout>
      <ProSpaceModal
        v-model="showModal"
        width="410"
        :disabledApply="false"
        :title="$t('editItemTxt')"
        :icon="edit"
        @apply="changeItem"
        :cancelTxt="$t('cancelTxt')"
        :applyTxt="$t('applyTxt')"
      >
        <ProSpaceVLayout :gap="20">
          <ProSpaceInputText
            v-model="modalModel.name"
            :label="$t('marsPeriodName')"
            :placeholder="$t('marsPeriodName')"
          />
          <ProSpaceInputText
            v-model="modalModel.status"
            :label="$t('marsPeriodStatus')"
            :placeholder="$t('marsPeriodStatus')"
          />
          <ProSpaceDatePeriod
              :label="$t('period')"
              :model="modalModel"
              startDate="startDate"
              endDate="endDate"
              :dateFormat="userinfo.dateFormat"
            >
            </ProSpaceDatePeriod>
        </ProSpaceVLayout>
      </ProSpaceModal>
      <ProSpaceHistoryModal
        ref="history"
        v-model="showHistoryModal"
        modelName="MarsPeriodApiModel"
        @close="closeHistory"
      />
      <ProSpaceFlashMessage
        v-model="showClearModal"
        :applyTxt="$t('confirmTxt')"
        :cancelTxt="$t('cancelTxt')"
        :title="$t('questClearFilters')"
        @apply="actionClear"
        @cancel="actionCancelClear"
        :needHideApply="false"
      >
        {{ $t('bodyClearFilters') }}
      </ProSpaceFlashMessage>
    </template>
    <template #right>
      <MarsPeriodPanel
        v-if="hasSelect"
        ref="right-panel"
        :service="marsPeriodService"
        :model="selectedModel"
        :count="selectedCount"
        :clude="selectedClude"
        :options="dotsOptions"
        :is-all-rows-selected="isAllRowsSelected"
        @clear="selectedMultipleReset"
        @clear:excluded="clearExcluded"
        @edit="editItem"
        @delete="deleteItem"
        @history="showHistory"
      />
    </template>
  </ProSpaceGeoLayout>
  <ModalBlockFilters />
</template>
<script>
import {
  ProSpaceFilterPanel,
  ProSpaceCustomFilterPanel,
  ProSpaceMultiSelect,
  ProSpaceMainGrid,
  ProSpaceDots,
  ProSpaceModal,
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceIconButton,
  ProSpaceButton,
  ProSpaceTableHeaderCell,
  ProSpaceDateColumn,
  ProSpaceDefaultTextColumn,
  ProSpaceEmptyGrid,
  ProSpaceLeftPanel,
  ProSpaceTree,
  ProSpaceVLayout,
  ProSpaceFilterContainsChips,
  ProSpaceFilterDatesRange,
  ProSpaceDropdown,
  ProSpaceDatePeriod,
  ProSpaceInputNumber,
  ProSpaceInputSwitch,
  ProSpaceInputText,
  ProSpaceFlashMessage
} from "@prospace/prospace-components-library";
import { MarsPeriodService } from "../../services/MarsPeriodService.js";
import { MarsPeriodStatusService } from "../../services/MarsPeriodStatusService.js";
import { MarsPeriodBlockingAdjustmentsService } from "../../services/MarsPeriodBlockingAdjustmentsService";

import Column from "primevue/column";
import MarsPeriodPanel from "./components/MarsPeriodPanel";
import ProSpaceHistoryModal from "../../../../../Frontends/ProSpace/components/modals/ProSpaceHistoryModal.vue";
import MarsPeriodModalImport from "./components/MarsPeriodModalImport";
import {
  useMultiSelectGrid,
} from "@composes/multiselect";
import ModalBlockFilters from "@multiselect/ModalBlockFilters"
import { ref } from "vue"
const _ = require("lodash");
import { mapGetters } from "vuex";
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
export default {
  mixins: [accessMixin],
  components: {
    ProSpaceFilterPanel,
    ProSpaceCustomFilterPanel,
    ProSpaceMultiSelect,
    ProSpaceMainGrid,
    ProSpaceDots,
    ProSpaceModal,
    Column,
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceIconButton,
    ProSpaceButton,
    ProSpaceTableHeaderCell,
    ProSpaceDateColumn,
    ProSpaceDefaultTextColumn,
    ProSpaceEmptyGrid,
    MarsPeriodPanel,
    ProSpaceHistoryModal,
    ProSpaceLeftPanel,
    ProSpaceTree,
    ProSpaceVLayout,
    ProSpaceFilterContainsChips,
    ProSpaceFilterDatesRange,
    ProSpaceDropdown,
    ProSpaceDatePeriod,
    ProSpaceInputNumber,
    ProSpaceInputSwitch,
    ProSpaceInputText,
    MarsPeriodModalImport,
    ProSpaceFlashMessage,
    ModalBlockFilters
  },
  setup() {
    const grid = ref(null)
    const filterPanel = ref(null)
    const {
      selectedMultipleGridHandler,
      selectedMultipleClear,
      selectedData,
      selectedCount,
      hasSelect,
      selectedMultipleBlockFilterHandler,
      needBlock,
      getRequestModel,
      selectedMultipleReset,
      setSelected
    } = useMultiSelectGrid(grid, filterPanel)
    return {
      grid, filterPanel,
      selectedMultipleGridHandler, selectedData,
      hasSelect, selectedMultipleClear,
      selectedMultipleBlockFilterHandler,
      needBlock, selectedCount,
      getRequestModel,
      selectedMultipleReset,
      setSelected
    }
  },
  data() {
    return {
      showModal: false,
      showImportModal: false,
      showHistoryModal: false,
      // Grid Panel
      selectedModel: null,
      selectedCount: null,
      selectedClude: null,
      showClearModal: false,

      // Service
      marsPeriodService: new MarsPeriodService(),
      marsPeriodStatusService: new MarsPeriodStatusService(),
      marsPeriodBlockingAdjustmentsService: new MarsPeriodBlockingAdjustmentsService(),
      //InlinePanel
      masterId: null,
      isEdit: false,
      isCreate: false,
      modalModel: {},

      // Multi filter
      modelFastFilter: {
        label: this.$t("allTxt"),
        value: false,
        field: "disabled",
      },
      isAllRowsSelected: false,
      disabledBlockingAdjustmentsAction: false
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      access: "securityRoleAccess/access",
    }),
    customServices() {
      return [
        {
          service: new MarsPeriodBlockingAdjustmentsService(),
          type: "checkboxes",
          model: "isBlocked",
          getMethod: "getBlockingAdjustmentsStatuses",
          optionValue: "value",
          optionLabel: "text",
          label: this.$t("blockingAdjustments"),
          placeholder: this.$t("blockingAdjustments"),
          needSelectAll: true,
          selected: {},
        },
        {
          optionValue: "date",
          type: "dates-range",
          model: "startDate",
          label: this.$t("marsPeriodStartDate"),
          selected: {},
        },
        {
          optionValue: "date",
          type: "dates-range",
          model: "endDate",
          label: this.$t("marsPeriodEndDate"),
          selected: {},
        },
        {
          type: "chips",
          model: "createdBy",
          label: this.$t("createdByTxt"),
          selected: {},
        },
        {
          type: "chips",
          model: "updatedBy",
          label: this.$t("updatedByTxt"),
          selected: {},
        },
        {
          type: "dates-range-time",
          model: "createdAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
        {
          type: "dates-range-time",
          model: "lastUpdated",
          label: this.$t("lastUpdatedTxt"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
      ];
    },
    dotsOptions() {
      let res = [
        {
          name: "showHistory",
          text: this.$t("history"),
          icon: "history",
          method: this.showHistory,
        },
      ];
      if (this.modelFastFilter.label === this.$t("deleted")) {
        res = res.filter(
          (option) => option.name !== "edit" && option.name !== "delete"
        );
      }
      return res;
    },
    fastFilters() {
      return [
        { label: this.$t("allTxt"), field: "disabled", value: false },
        { label: this.$t("deleted"), field: "disabled", value: true },
      ];
    },
    canShowBlockingAdjustmentsAction() {
      return this.checkAccess('action-blockingAdjustments') && this.selectedData && Object.keys(this.selectedData).length > 0;
    },
    getDisabledBlockingAdjustmentsAction() {
      return (!this.selectedData || Object.keys(this.selectedData).length === 0) ||
        this.selectedData?.status === 'closed' ||
        this.disabledBlockingAdjustmentsAction;
    }
  },
  methods: {
    checkIsAllRowsSelected() {
      this.$nextTick(() => {
        this.isAllRowsSelected = this.grid.isAllRowsSelected
      })
    },
    handlerBlockFilterPanel({ tab }) {
      this.showClearModal = true
      this.actionClear = () => {
        this.selectedMultipleClear()
        if (tab) {
          this.filterPanel.fastFilter = tab
        }
        this.$nextTick(() => {
          this.filterPanel.submitFilter()
          this.showClearModal = false
        })
      }
      this.actionCancelClear = () => {
        this.showClearModal = false
      }
    },
    closeHistory() {
      this.showHistoryModal = false;
    },
    showHistory(record) {
      this.$refs.history.tabs[0].masterId = record.id;
      this.$refs.history.masterName = record.code;
      this.$nextTick(() => {
        this.showHistoryModal = true;
      });
    },
    toItem(data) {
      this.$router.push(`/addressprogramarchived/marsperiod/${data.id}`);
    },
    submitFilter({ filter, search }) {
      this.grid.submitFilter(filter, search);
    },
    emitFilter() {
      this.filterPanel.submitFilter();
    },
    customFilterApply(filter, model) {
      filter = Object.assign(filter, model);
      this.filterPanel.submitFilter();
    },
    actionUpdate() {
      this.grid.getRecords(true);
      if (this.$refs["right-panel"]) {
        this.$refs["right-panel"].update();
      }
    },
    actionExport(format) {
      this.loadingHandler(true);
      this.marsPeriodService
        .export(this.grid.getRecords(false, true), format)
        .then(() => this.loadingHandler(false));
      //TODO: Catch error?
      //TODO: Show message(export task created)
    },
    actionImport() {
      this.showImportModal = true;
    },
    loadingHandler(val) {
      this.grid.loading = val;
    },
    selectedHandler(val) {
      this.checkIsAllRowsSelected();
      this.selectedMultipleGridHandler(val)
    },
    showChangeModal() {
      this.isEdit = false;
      this.isCreate = true;
      this.modalModel = {};
      this.showModal = true;
    },
    clear() {
      if (this.grid) {
        this.selectedModel = null;
        this.selectedCount = null;
        this.selectedClude = null;
        this.grid.selectedModel = [];
        this.grid.clickedItem = null;
        this.grid.isAllRowsSelected = false;
      }
    },
    clearExcluded() {
      if (this.grid) {
        this.selectedModel = null;
        this.selectedCount = this.grid?.records.length;
        this.selectedClude = {
          items: [],
          isAll: true
        };
        this.grid.selectedModel = [];
        this.grid.isAllRowsSelected = true;
      }
    },
    editItem(model) {
      if (!model) return;
      this.isEdit = true;
      this.isCreate = false;
      this.modalModel = _.cloneDeep(model);
      this.showModal = true;
    },
    changeItem() {
      let method = "update";
      this.marsPeriodService[method](this.modalModel).then(() => {
        this.actionUpdate();
      });
    },
    deleteItem(model) {
      if (!model) return;
      this.marsPeriodService.delete(model).then(() => {
        this.actionUpdate();
        this.selectedModel = {};
      });
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    handleDots(action, item) {
      var option = this.dotsOptions.find((o) => o.name === action);
      option.method(item);
    },
    getBlockingAdjustmentsValue(value) {
      if (value) {
        return this.$t('yes');
      } else {
        return this.$t('no');
      }
    },
    changeBlockingAdjustments() {
      this.disabledBlockingAdjustmentsAction = true;
      let { id,  isBlocked } = this.selectedData;
      isBlocked = !isBlocked;
      const model = { periodId: id, isBlocked };
      this.marsPeriodService.blockMarsPeriod(model).then((result) => {
        const {data} = result.data;
        this.actionUpdate();
        this.$nextTick(() => {
          this.setSelected({ data });
        });
      }).finally(() => {
        this.disabledBlockingAdjustmentsAction = false;
      });
    }
  },
  mounted() {
    this.loadRoleAccess();
  },
};
</script>
<style lang="scss"></style>
